import { toast } from 'react-toastify';
import { CheckCircle, Info, AlertTriangle, XCircle } from 'lucide-react';

const useAlert = () => {
  const showAlert = (type, message, options = {}) => {
    const toastOptions = {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      icon:false,
      ...options
    };

    const getIcon = (alertType) => {
      const iconProps = { size: 20, style: { marginRight: '8px' } };
      
      const icons = {
        success: <CheckCircle {...iconProps} color="#10b981" />,
        info: <Info {...iconProps} color="#3b82f6" />,
        warning: <AlertTriangle {...iconProps} color="#f59e0b" />,
        error: <XCircle {...iconProps} color="#ef4444" />
      };
      
      return icons[alertType];
    };

    const messageWithIcon = (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {getIcon(type)}
        <span>{message}</span>
      </div>
    );

    switch (type) {
      case 'success':
        return toast.success(messageWithIcon, toastOptions);
      case 'info':
        return toast.info(messageWithIcon, toastOptions);
      case 'warning':
        return toast.warn(messageWithIcon, toastOptions);
      case 'error':
        return toast.error(messageWithIcon, toastOptions);
      default:
        return toast(messageWithIcon, toastOptions);
    }
  };

  const showSuccess = (message, options = {}) => showAlert('success', message, options);
  const showInfo = (message, options = {}) => showAlert('info', message, options);
  const showWarning = (message, options = {}) => showAlert('warning', message, options);
  const showError = (message, options = {}) => showAlert('error', message, options);

  const dismissAll = () => toast.dismiss();

  return {
    showAlert,
    showSuccess,
    showInfo,
    showWarning,
    showError,
    dismissAll
  };
};

export default useAlert;